import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminChatAddBookmark = (chatId) => {
  return axiosClient.get(`/api/admin/im/mark/${chatId}`).then((r) => r.data);
};
